import React from 'react';

import {
    Alignable,
    Button,
    ButtonList,
    ButtonVariant,
    Justifiable,
    Modal,
    ModalBody,
    ModalFooter,
    View,
} from '@bytel/trilogy-react';

import { EnergyLabelType } from '@app-types/product';

type EnergyLabelModalProps = {
    onClose: () => void;
    energyLabel?: Partial<EnergyLabelType>;
};

export function EnergyLabelModal({ energyLabel, onClose }: Readonly<EnergyLabelModalProps>) {
    return (
        <Modal active onClose={onClose} title='Étiquette énergétique'>
            <ModalBody>
                <View flexable justify={Justifiable.JUSTIFIED_CENTER}>
                    <img height={150} width={300} src={energyLabel?.img ?? ''} alt={energyLabel?.label ?? ''} />
                </View>
            </ModalBody>
            <ModalFooter>
                <ButtonList align={Alignable.ALIGNED_END}>
                    <Button variant={ButtonVariant.PRIMARY} onClick={onClose}>
                        Fermer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
